import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberCircleFour = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15.5322C11.3137 15.5322 14 12.8459 14 9.53223C14 6.21852 11.3137 3.53223 8 3.53223C4.68629 3.53223 2 6.21852 2 9.53223C2 12.8459 4.68629 15.5322 8 15.5322Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 6.28223L6.25 10.5322H9.25",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.25 8.53223V12.5322",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNumberCircleFour;
